<template>
  <section class="bg-no-repeat pt-24 md:pt-12" >
    <div style="" :style="styles"
      class="hero-header bg-no-repeat w-full flex md:flex-row flex-col gap-12 items-center justify-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-left w-full md:w-1/2">

        <div
          class="mb-4 inline-block bg-linear-to-tr from-secondary-500 to-primary-500 text-white pl-3 pr-4 py-1 rounded-tl-xl rounded-br-xl border-primary-500 border shadow-md">

          <div class="flex flex-row items-center gap-3 ">
            <component :is="icon" class="w-5 h-5" />
            <div class="text-sm">{{ featureName }}</div>
          </div>
        </div>

        <div class="text-3xl text-center md:text-left md:text-5xl text-gray-800 font-headings">
          <slot name="title" />
        </div>
        <div class="text-lg text-center md:text-left text-gray-700 mt-8 font-body leading-6">
          <slot name="description" />
        </div>

        <div class="flex flex-row gap-4 mt-8">
          <a href='/signup' class="inline-flex"><Button text="Sign up Now" variant="accent" hasArrow size="md" /></a>
          <a href='/contact' class="inline-flex"><Button text="Talk to our team" variant="primary" size="md" /></a>
        </div>
      </div>
      <div class="w-full md:w-1/2">
        <slot name="content" />
      </div>

    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import Button from './Buttons/Button.vue'

const props = defineProps({
  icon: {
    type: Object,
    default: null
  },
  featureName: {
    type: String,
    default: ''
  },
  backgroundImage: {
    type: String,
    default: ''
  }
})

const styles = computed(() => {
  if (props.backgroundImage) {
    return {
      backgroundImage: `url(${props.backgroundImage})`
    }
  }
  return {}
})
// Hero section component
</script>

<style scoped>
@media (min-width: 768px) {
  .hero-header {
    height: calc(100vh - 100px);
    max-height: 700px;
    min-height: 500px;
    background-size: 300px;
    background-position: right 20px bottom 80px;
  }
}
</style>